const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveAgentReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_AGENT_SGH_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_AGENT_SGH_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_AGENT_SGH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveAgentReducer